import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getList = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.tags.list;
  const search = data.search ? `&search=${data.search}` : '';

  return fetch(
    `${endpoint}?platformId=${data.platformId}${search}${authenticity_token ? `&authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const create = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.tags.create;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getTags = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.tags.tags;
  const search = data.search ? `&search=${data.search}` : '';

  return fetch(
    `${endpoint}?platformId=${data.platformId}${search}${authenticity_token ? `&authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};
export const tagsService = {
  getList,
  create,
  getTags,
};
